module.exports = __webpack_public_path__ + "img/orbit-college-logo-icon.352f5c73.png";